import * as CHAIN_1_IMPORT from "./1";
// import * as CHAIN_18_IMPORT from "./18";
// import * as CHAIN188_IMPORT from "./188";
import * as CHAIN_4161_IMPORT from "./42161";
// import * as CHAIN_41618_IMPORT from "./421618";
// import * as CHAIN_416188_IMPORT from "./4216188";
export const chains = {
	1: CHAIN_1_IMPORT,
	// 18: CHAIN_18_IMPORT,
	// 188: CHAIN188_IMPORT,
	42161: CHAIN_4161_IMPORT,
	// 421618: CHAIN_41618_IMPORT,
	// 4216188: CHAIN_416188_IMPORT,
};
